// source: api/tracking.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var location_proto_pb = require('../location_proto_pb.js');
goog.object.extend(proto, location_proto_pb);
var route_proto_pb = require('../route_proto_pb.js');
goog.object.extend(proto, route_proto_pb);
var timestamp_proto_pb = require('../timestamp_proto_pb.js');
goog.object.extend(proto, timestamp_proto_pb);
var tracking_session_proto_pb = require('../tracking_session_proto_pb.js');
goog.object.extend(proto, tracking_session_proto_pb);
var waypoint_proto_pb = require('../waypoint_proto_pb.js');
goog.object.extend(proto, waypoint_proto_pb);
goog.exportSymbol('proto.somewear.api.v1.CreateTrackingLocationsRequest', null, global);
goog.exportSymbol('proto.somewear.api.v1.CreateWaypointRequest', null, global);
goog.exportSymbol('proto.somewear.api.v1.DeleteRouteRequest', null, global);
goog.exportSymbol('proto.somewear.api.v1.ExportGpxRequest', null, global);
goog.exportSymbol('proto.somewear.api.v1.ExportGpxResponse', null, global);
goog.exportSymbol('proto.somewear.api.v1.GetLastKnownRoutesRequest', null, global);
goog.exportSymbol('proto.somewear.api.v1.GetLastKnownRoutesResponse', null, global);
goog.exportSymbol('proto.somewear.api.v1.GetLiveRoutesRequest', null, global);
goog.exportSymbol('proto.somewear.api.v1.GetLiveRoutesResponse', null, global);
goog.exportSymbol('proto.somewear.api.v1.GetLocationsRequest', null, global);
goog.exportSymbol('proto.somewear.api.v1.GetLocationsResponse', null, global);
goog.exportSymbol('proto.somewear.api.v1.GetRouteLocationsRequest', null, global);
goog.exportSymbol('proto.somewear.api.v1.GetRouteLocationsResponse', null, global);
goog.exportSymbol('proto.somewear.api.v1.GetRoutesRequest', null, global);
goog.exportSymbol('proto.somewear.api.v1.GetRoutesResponse', null, global);
goog.exportSymbol('proto.somewear.api.v1.GetWaypointsRequest', null, global);
goog.exportSymbol('proto.somewear.api.v1.GetWaypointsResponse', null, global);
goog.exportSymbol('proto.somewear.api.v1.GetWorkspaceRoutesRequest', null, global);
goog.exportSymbol('proto.somewear.api.v1.GetWorkspaceRoutesRequest.RouteType', null, global);
goog.exportSymbol('proto.somewear.api.v1.GetWorkspaceRoutesResponse', null, global);
goog.exportSymbol('proto.somewear.api.v1.LocationStreamRequest', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.somewear.api.v1.LocationStreamRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.somewear.api.v1.LocationStreamRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.somewear.api.v1.LocationStreamRequest.displayName = 'proto.somewear.api.v1.LocationStreamRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.somewear.api.v1.GetLocationsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.somewear.api.v1.GetLocationsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.somewear.api.v1.GetLocationsRequest.displayName = 'proto.somewear.api.v1.GetLocationsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.somewear.api.v1.GetLocationsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.somewear.api.v1.GetLocationsResponse.repeatedFields_, null);
};
goog.inherits(proto.somewear.api.v1.GetLocationsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.somewear.api.v1.GetLocationsResponse.displayName = 'proto.somewear.api.v1.GetLocationsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.somewear.api.v1.CreateTrackingLocationsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.somewear.api.v1.CreateTrackingLocationsRequest.repeatedFields_, null);
};
goog.inherits(proto.somewear.api.v1.CreateTrackingLocationsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.somewear.api.v1.CreateTrackingLocationsRequest.displayName = 'proto.somewear.api.v1.CreateTrackingLocationsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.somewear.api.v1.CreateWaypointRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.somewear.api.v1.CreateWaypointRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.somewear.api.v1.CreateWaypointRequest.displayName = 'proto.somewear.api.v1.CreateWaypointRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.somewear.api.v1.DeleteRouteRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.somewear.api.v1.DeleteRouteRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.somewear.api.v1.DeleteRouteRequest.displayName = 'proto.somewear.api.v1.DeleteRouteRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.somewear.api.v1.GetLiveRoutesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.somewear.api.v1.GetLiveRoutesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.somewear.api.v1.GetLiveRoutesRequest.displayName = 'proto.somewear.api.v1.GetLiveRoutesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.somewear.api.v1.GetLiveRoutesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.somewear.api.v1.GetLiveRoutesResponse.repeatedFields_, null);
};
goog.inherits(proto.somewear.api.v1.GetLiveRoutesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.somewear.api.v1.GetLiveRoutesResponse.displayName = 'proto.somewear.api.v1.GetLiveRoutesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.somewear.api.v1.GetLastKnownRoutesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.somewear.api.v1.GetLastKnownRoutesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.somewear.api.v1.GetLastKnownRoutesRequest.displayName = 'proto.somewear.api.v1.GetLastKnownRoutesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.somewear.api.v1.GetLastKnownRoutesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.somewear.api.v1.GetLastKnownRoutesResponse.repeatedFields_, null);
};
goog.inherits(proto.somewear.api.v1.GetLastKnownRoutesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.somewear.api.v1.GetLastKnownRoutesResponse.displayName = 'proto.somewear.api.v1.GetLastKnownRoutesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.somewear.api.v1.GetRoutesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.somewear.api.v1.GetRoutesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.somewear.api.v1.GetRoutesRequest.displayName = 'proto.somewear.api.v1.GetRoutesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.somewear.api.v1.GetRoutesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.somewear.api.v1.GetRoutesResponse.repeatedFields_, null);
};
goog.inherits(proto.somewear.api.v1.GetRoutesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.somewear.api.v1.GetRoutesResponse.displayName = 'proto.somewear.api.v1.GetRoutesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.somewear.api.v1.GetWorkspaceRoutesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.somewear.api.v1.GetWorkspaceRoutesRequest.repeatedFields_, null);
};
goog.inherits(proto.somewear.api.v1.GetWorkspaceRoutesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.somewear.api.v1.GetWorkspaceRoutesRequest.displayName = 'proto.somewear.api.v1.GetWorkspaceRoutesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.somewear.api.v1.GetWorkspaceRoutesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.somewear.api.v1.GetWorkspaceRoutesResponse.repeatedFields_, null);
};
goog.inherits(proto.somewear.api.v1.GetWorkspaceRoutesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.somewear.api.v1.GetWorkspaceRoutesResponse.displayName = 'proto.somewear.api.v1.GetWorkspaceRoutesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.somewear.api.v1.GetWaypointsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.somewear.api.v1.GetWaypointsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.somewear.api.v1.GetWaypointsRequest.displayName = 'proto.somewear.api.v1.GetWaypointsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.somewear.api.v1.GetWaypointsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.somewear.api.v1.GetWaypointsResponse.repeatedFields_, null);
};
goog.inherits(proto.somewear.api.v1.GetWaypointsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.somewear.api.v1.GetWaypointsResponse.displayName = 'proto.somewear.api.v1.GetWaypointsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.somewear.api.v1.GetRouteLocationsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.somewear.api.v1.GetRouteLocationsRequest.repeatedFields_, null);
};
goog.inherits(proto.somewear.api.v1.GetRouteLocationsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.somewear.api.v1.GetRouteLocationsRequest.displayName = 'proto.somewear.api.v1.GetRouteLocationsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.somewear.api.v1.GetRouteLocationsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.somewear.api.v1.GetRouteLocationsResponse.repeatedFields_, null);
};
goog.inherits(proto.somewear.api.v1.GetRouteLocationsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.somewear.api.v1.GetRouteLocationsResponse.displayName = 'proto.somewear.api.v1.GetRouteLocationsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.somewear.api.v1.ExportGpxRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.somewear.api.v1.ExportGpxRequest.repeatedFields_, null);
};
goog.inherits(proto.somewear.api.v1.ExportGpxRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.somewear.api.v1.ExportGpxRequest.displayName = 'proto.somewear.api.v1.ExportGpxRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.somewear.api.v1.ExportGpxResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.somewear.api.v1.ExportGpxResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.somewear.api.v1.ExportGpxResponse.displayName = 'proto.somewear.api.v1.ExportGpxResponse';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.somewear.api.v1.LocationStreamRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.somewear.api.v1.LocationStreamRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.somewear.api.v1.LocationStreamRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.LocationStreamRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.somewear.api.v1.LocationStreamRequest}
 */
proto.somewear.api.v1.LocationStreamRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.somewear.api.v1.LocationStreamRequest;
  return proto.somewear.api.v1.LocationStreamRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.somewear.api.v1.LocationStreamRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.somewear.api.v1.LocationStreamRequest}
 */
proto.somewear.api.v1.LocationStreamRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.somewear.api.v1.LocationStreamRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.somewear.api.v1.LocationStreamRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.somewear.api.v1.LocationStreamRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.LocationStreamRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.somewear.api.v1.GetLocationsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.somewear.api.v1.GetLocationsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.somewear.api.v1.GetLocationsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.GetLocationsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
from: (f = msg.getFrom()) && timestamp_proto_pb.Timestamp.toObject(includeInstance, f),
to: (f = msg.getTo()) && timestamp_proto_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.somewear.api.v1.GetLocationsRequest}
 */
proto.somewear.api.v1.GetLocationsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.somewear.api.v1.GetLocationsRequest;
  return proto.somewear.api.v1.GetLocationsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.somewear.api.v1.GetLocationsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.somewear.api.v1.GetLocationsRequest}
 */
proto.somewear.api.v1.GetLocationsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new timestamp_proto_pb.Timestamp;
      reader.readMessage(value,timestamp_proto_pb.Timestamp.deserializeBinaryFromReader);
      msg.setFrom(value);
      break;
    case 2:
      var value = new timestamp_proto_pb.Timestamp;
      reader.readMessage(value,timestamp_proto_pb.Timestamp.deserializeBinaryFromReader);
      msg.setTo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.somewear.api.v1.GetLocationsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.somewear.api.v1.GetLocationsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.somewear.api.v1.GetLocationsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.GetLocationsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFrom();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      timestamp_proto_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getTo();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      timestamp_proto_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional Timestamp from = 1;
 * @return {?proto.Timestamp}
 */
proto.somewear.api.v1.GetLocationsRequest.prototype.getFrom = function() {
  return /** @type{?proto.Timestamp} */ (
    jspb.Message.getWrapperField(this, timestamp_proto_pb.Timestamp, 1));
};


/**
 * @param {?proto.Timestamp|undefined} value
 * @return {!proto.somewear.api.v1.GetLocationsRequest} returns this
*/
proto.somewear.api.v1.GetLocationsRequest.prototype.setFrom = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.somewear.api.v1.GetLocationsRequest} returns this
 */
proto.somewear.api.v1.GetLocationsRequest.prototype.clearFrom = function() {
  return this.setFrom(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.somewear.api.v1.GetLocationsRequest.prototype.hasFrom = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Timestamp to = 2;
 * @return {?proto.Timestamp}
 */
proto.somewear.api.v1.GetLocationsRequest.prototype.getTo = function() {
  return /** @type{?proto.Timestamp} */ (
    jspb.Message.getWrapperField(this, timestamp_proto_pb.Timestamp, 2));
};


/**
 * @param {?proto.Timestamp|undefined} value
 * @return {!proto.somewear.api.v1.GetLocationsRequest} returns this
*/
proto.somewear.api.v1.GetLocationsRequest.prototype.setTo = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.somewear.api.v1.GetLocationsRequest} returns this
 */
proto.somewear.api.v1.GetLocationsRequest.prototype.clearTo = function() {
  return this.setTo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.somewear.api.v1.GetLocationsRequest.prototype.hasTo = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.somewear.api.v1.GetLocationsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.somewear.api.v1.GetLocationsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.somewear.api.v1.GetLocationsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.somewear.api.v1.GetLocationsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.GetLocationsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
locationsList: jspb.Message.toObjectList(msg.getLocationsList(),
    location_proto_pb.LocationResponse.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.somewear.api.v1.GetLocationsResponse}
 */
proto.somewear.api.v1.GetLocationsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.somewear.api.v1.GetLocationsResponse;
  return proto.somewear.api.v1.GetLocationsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.somewear.api.v1.GetLocationsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.somewear.api.v1.GetLocationsResponse}
 */
proto.somewear.api.v1.GetLocationsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new location_proto_pb.LocationResponse;
      reader.readMessage(value,location_proto_pb.LocationResponse.deserializeBinaryFromReader);
      msg.addLocations(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.somewear.api.v1.GetLocationsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.somewear.api.v1.GetLocationsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.somewear.api.v1.GetLocationsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.GetLocationsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLocationsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      location_proto_pb.LocationResponse.serializeBinaryToWriter
    );
  }
};


/**
 * repeated LocationResponse locations = 1;
 * @return {!Array<!proto.LocationResponse>}
 */
proto.somewear.api.v1.GetLocationsResponse.prototype.getLocationsList = function() {
  return /** @type{!Array<!proto.LocationResponse>} */ (
    jspb.Message.getRepeatedWrapperField(this, location_proto_pb.LocationResponse, 1));
};


/**
 * @param {!Array<!proto.LocationResponse>} value
 * @return {!proto.somewear.api.v1.GetLocationsResponse} returns this
*/
proto.somewear.api.v1.GetLocationsResponse.prototype.setLocationsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.LocationResponse=} opt_value
 * @param {number=} opt_index
 * @return {!proto.LocationResponse}
 */
proto.somewear.api.v1.GetLocationsResponse.prototype.addLocations = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.LocationResponse, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.somewear.api.v1.GetLocationsResponse} returns this
 */
proto.somewear.api.v1.GetLocationsResponse.prototype.clearLocationsList = function() {
  return this.setLocationsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.somewear.api.v1.CreateTrackingLocationsRequest.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.somewear.api.v1.CreateTrackingLocationsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.somewear.api.v1.CreateTrackingLocationsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.somewear.api.v1.CreateTrackingLocationsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.CreateTrackingLocationsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
locationsList: jspb.Message.toObjectList(msg.getLocationsList(),
    tracking_session_proto_pb.TrackingLocationDto.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.somewear.api.v1.CreateTrackingLocationsRequest}
 */
proto.somewear.api.v1.CreateTrackingLocationsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.somewear.api.v1.CreateTrackingLocationsRequest;
  return proto.somewear.api.v1.CreateTrackingLocationsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.somewear.api.v1.CreateTrackingLocationsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.somewear.api.v1.CreateTrackingLocationsRequest}
 */
proto.somewear.api.v1.CreateTrackingLocationsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new tracking_session_proto_pb.TrackingLocationDto;
      reader.readMessage(value,tracking_session_proto_pb.TrackingLocationDto.deserializeBinaryFromReader);
      msg.addLocations(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.somewear.api.v1.CreateTrackingLocationsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.somewear.api.v1.CreateTrackingLocationsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.somewear.api.v1.CreateTrackingLocationsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.CreateTrackingLocationsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLocationsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      tracking_session_proto_pb.TrackingLocationDto.serializeBinaryToWriter
    );
  }
};


/**
 * repeated TrackingLocationDto locations = 1;
 * @return {!Array<!proto.TrackingLocationDto>}
 */
proto.somewear.api.v1.CreateTrackingLocationsRequest.prototype.getLocationsList = function() {
  return /** @type{!Array<!proto.TrackingLocationDto>} */ (
    jspb.Message.getRepeatedWrapperField(this, tracking_session_proto_pb.TrackingLocationDto, 1));
};


/**
 * @param {!Array<!proto.TrackingLocationDto>} value
 * @return {!proto.somewear.api.v1.CreateTrackingLocationsRequest} returns this
*/
proto.somewear.api.v1.CreateTrackingLocationsRequest.prototype.setLocationsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.TrackingLocationDto=} opt_value
 * @param {number=} opt_index
 * @return {!proto.TrackingLocationDto}
 */
proto.somewear.api.v1.CreateTrackingLocationsRequest.prototype.addLocations = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.TrackingLocationDto, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.somewear.api.v1.CreateTrackingLocationsRequest} returns this
 */
proto.somewear.api.v1.CreateTrackingLocationsRequest.prototype.clearLocationsList = function() {
  return this.setLocationsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.somewear.api.v1.CreateWaypointRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.somewear.api.v1.CreateWaypointRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.somewear.api.v1.CreateWaypointRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.CreateWaypointRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
waypoint: (f = msg.getWaypoint()) && waypoint_proto_pb.CreateWaypoint.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.somewear.api.v1.CreateWaypointRequest}
 */
proto.somewear.api.v1.CreateWaypointRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.somewear.api.v1.CreateWaypointRequest;
  return proto.somewear.api.v1.CreateWaypointRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.somewear.api.v1.CreateWaypointRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.somewear.api.v1.CreateWaypointRequest}
 */
proto.somewear.api.v1.CreateWaypointRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new waypoint_proto_pb.CreateWaypoint;
      reader.readMessage(value,waypoint_proto_pb.CreateWaypoint.deserializeBinaryFromReader);
      msg.setWaypoint(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.somewear.api.v1.CreateWaypointRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.somewear.api.v1.CreateWaypointRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.somewear.api.v1.CreateWaypointRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.CreateWaypointRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getWaypoint();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      waypoint_proto_pb.CreateWaypoint.serializeBinaryToWriter
    );
  }
};


/**
 * optional CreateWaypoint waypoint = 1;
 * @return {?proto.CreateWaypoint}
 */
proto.somewear.api.v1.CreateWaypointRequest.prototype.getWaypoint = function() {
  return /** @type{?proto.CreateWaypoint} */ (
    jspb.Message.getWrapperField(this, waypoint_proto_pb.CreateWaypoint, 1));
};


/**
 * @param {?proto.CreateWaypoint|undefined} value
 * @return {!proto.somewear.api.v1.CreateWaypointRequest} returns this
*/
proto.somewear.api.v1.CreateWaypointRequest.prototype.setWaypoint = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.somewear.api.v1.CreateWaypointRequest} returns this
 */
proto.somewear.api.v1.CreateWaypointRequest.prototype.clearWaypoint = function() {
  return this.setWaypoint(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.somewear.api.v1.CreateWaypointRequest.prototype.hasWaypoint = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.somewear.api.v1.DeleteRouteRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.somewear.api.v1.DeleteRouteRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.somewear.api.v1.DeleteRouteRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.DeleteRouteRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
routeId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.somewear.api.v1.DeleteRouteRequest}
 */
proto.somewear.api.v1.DeleteRouteRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.somewear.api.v1.DeleteRouteRequest;
  return proto.somewear.api.v1.DeleteRouteRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.somewear.api.v1.DeleteRouteRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.somewear.api.v1.DeleteRouteRequest}
 */
proto.somewear.api.v1.DeleteRouteRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRouteId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.somewear.api.v1.DeleteRouteRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.somewear.api.v1.DeleteRouteRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.somewear.api.v1.DeleteRouteRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.DeleteRouteRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRouteId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string route_id = 1;
 * @return {string}
 */
proto.somewear.api.v1.DeleteRouteRequest.prototype.getRouteId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.somewear.api.v1.DeleteRouteRequest} returns this
 */
proto.somewear.api.v1.DeleteRouteRequest.prototype.setRouteId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.somewear.api.v1.GetLiveRoutesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.somewear.api.v1.GetLiveRoutesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.somewear.api.v1.GetLiveRoutesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.GetLiveRoutesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.somewear.api.v1.GetLiveRoutesRequest}
 */
proto.somewear.api.v1.GetLiveRoutesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.somewear.api.v1.GetLiveRoutesRequest;
  return proto.somewear.api.v1.GetLiveRoutesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.somewear.api.v1.GetLiveRoutesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.somewear.api.v1.GetLiveRoutesRequest}
 */
proto.somewear.api.v1.GetLiveRoutesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.somewear.api.v1.GetLiveRoutesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.somewear.api.v1.GetLiveRoutesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.somewear.api.v1.GetLiveRoutesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.GetLiveRoutesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.somewear.api.v1.GetLiveRoutesResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.somewear.api.v1.GetLiveRoutesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.somewear.api.v1.GetLiveRoutesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.somewear.api.v1.GetLiveRoutesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.GetLiveRoutesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
routesList: jspb.Message.toObjectList(msg.getRoutesList(),
    route_proto_pb.RouteResponse.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.somewear.api.v1.GetLiveRoutesResponse}
 */
proto.somewear.api.v1.GetLiveRoutesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.somewear.api.v1.GetLiveRoutesResponse;
  return proto.somewear.api.v1.GetLiveRoutesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.somewear.api.v1.GetLiveRoutesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.somewear.api.v1.GetLiveRoutesResponse}
 */
proto.somewear.api.v1.GetLiveRoutesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new route_proto_pb.RouteResponse;
      reader.readMessage(value,route_proto_pb.RouteResponse.deserializeBinaryFromReader);
      msg.addRoutes(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.somewear.api.v1.GetLiveRoutesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.somewear.api.v1.GetLiveRoutesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.somewear.api.v1.GetLiveRoutesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.GetLiveRoutesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRoutesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      route_proto_pb.RouteResponse.serializeBinaryToWriter
    );
  }
};


/**
 * repeated RouteResponse routes = 1;
 * @return {!Array<!proto.RouteResponse>}
 */
proto.somewear.api.v1.GetLiveRoutesResponse.prototype.getRoutesList = function() {
  return /** @type{!Array<!proto.RouteResponse>} */ (
    jspb.Message.getRepeatedWrapperField(this, route_proto_pb.RouteResponse, 1));
};


/**
 * @param {!Array<!proto.RouteResponse>} value
 * @return {!proto.somewear.api.v1.GetLiveRoutesResponse} returns this
*/
proto.somewear.api.v1.GetLiveRoutesResponse.prototype.setRoutesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.RouteResponse=} opt_value
 * @param {number=} opt_index
 * @return {!proto.RouteResponse}
 */
proto.somewear.api.v1.GetLiveRoutesResponse.prototype.addRoutes = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.RouteResponse, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.somewear.api.v1.GetLiveRoutesResponse} returns this
 */
proto.somewear.api.v1.GetLiveRoutesResponse.prototype.clearRoutesList = function() {
  return this.setRoutesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.somewear.api.v1.GetLastKnownRoutesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.somewear.api.v1.GetLastKnownRoutesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.somewear.api.v1.GetLastKnownRoutesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.GetLastKnownRoutesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.somewear.api.v1.GetLastKnownRoutesRequest}
 */
proto.somewear.api.v1.GetLastKnownRoutesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.somewear.api.v1.GetLastKnownRoutesRequest;
  return proto.somewear.api.v1.GetLastKnownRoutesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.somewear.api.v1.GetLastKnownRoutesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.somewear.api.v1.GetLastKnownRoutesRequest}
 */
proto.somewear.api.v1.GetLastKnownRoutesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.somewear.api.v1.GetLastKnownRoutesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.somewear.api.v1.GetLastKnownRoutesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.somewear.api.v1.GetLastKnownRoutesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.GetLastKnownRoutesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.somewear.api.v1.GetLastKnownRoutesResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.somewear.api.v1.GetLastKnownRoutesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.somewear.api.v1.GetLastKnownRoutesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.somewear.api.v1.GetLastKnownRoutesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.GetLastKnownRoutesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
routesList: jspb.Message.toObjectList(msg.getRoutesList(),
    route_proto_pb.RouteResponse.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.somewear.api.v1.GetLastKnownRoutesResponse}
 */
proto.somewear.api.v1.GetLastKnownRoutesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.somewear.api.v1.GetLastKnownRoutesResponse;
  return proto.somewear.api.v1.GetLastKnownRoutesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.somewear.api.v1.GetLastKnownRoutesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.somewear.api.v1.GetLastKnownRoutesResponse}
 */
proto.somewear.api.v1.GetLastKnownRoutesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new route_proto_pb.RouteResponse;
      reader.readMessage(value,route_proto_pb.RouteResponse.deserializeBinaryFromReader);
      msg.addRoutes(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.somewear.api.v1.GetLastKnownRoutesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.somewear.api.v1.GetLastKnownRoutesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.somewear.api.v1.GetLastKnownRoutesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.GetLastKnownRoutesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRoutesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      route_proto_pb.RouteResponse.serializeBinaryToWriter
    );
  }
};


/**
 * repeated RouteResponse routes = 1;
 * @return {!Array<!proto.RouteResponse>}
 */
proto.somewear.api.v1.GetLastKnownRoutesResponse.prototype.getRoutesList = function() {
  return /** @type{!Array<!proto.RouteResponse>} */ (
    jspb.Message.getRepeatedWrapperField(this, route_proto_pb.RouteResponse, 1));
};


/**
 * @param {!Array<!proto.RouteResponse>} value
 * @return {!proto.somewear.api.v1.GetLastKnownRoutesResponse} returns this
*/
proto.somewear.api.v1.GetLastKnownRoutesResponse.prototype.setRoutesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.RouteResponse=} opt_value
 * @param {number=} opt_index
 * @return {!proto.RouteResponse}
 */
proto.somewear.api.v1.GetLastKnownRoutesResponse.prototype.addRoutes = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.RouteResponse, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.somewear.api.v1.GetLastKnownRoutesResponse} returns this
 */
proto.somewear.api.v1.GetLastKnownRoutesResponse.prototype.clearRoutesList = function() {
  return this.setRoutesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.somewear.api.v1.GetRoutesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.somewear.api.v1.GetRoutesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.somewear.api.v1.GetRoutesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.GetRoutesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
from: (f = msg.getFrom()) && timestamp_proto_pb.Timestamp.toObject(includeInstance, f),
to: (f = msg.getTo()) && timestamp_proto_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.somewear.api.v1.GetRoutesRequest}
 */
proto.somewear.api.v1.GetRoutesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.somewear.api.v1.GetRoutesRequest;
  return proto.somewear.api.v1.GetRoutesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.somewear.api.v1.GetRoutesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.somewear.api.v1.GetRoutesRequest}
 */
proto.somewear.api.v1.GetRoutesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new timestamp_proto_pb.Timestamp;
      reader.readMessage(value,timestamp_proto_pb.Timestamp.deserializeBinaryFromReader);
      msg.setFrom(value);
      break;
    case 2:
      var value = new timestamp_proto_pb.Timestamp;
      reader.readMessage(value,timestamp_proto_pb.Timestamp.deserializeBinaryFromReader);
      msg.setTo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.somewear.api.v1.GetRoutesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.somewear.api.v1.GetRoutesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.somewear.api.v1.GetRoutesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.GetRoutesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFrom();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      timestamp_proto_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getTo();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      timestamp_proto_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional Timestamp from = 1;
 * @return {?proto.Timestamp}
 */
proto.somewear.api.v1.GetRoutesRequest.prototype.getFrom = function() {
  return /** @type{?proto.Timestamp} */ (
    jspb.Message.getWrapperField(this, timestamp_proto_pb.Timestamp, 1));
};


/**
 * @param {?proto.Timestamp|undefined} value
 * @return {!proto.somewear.api.v1.GetRoutesRequest} returns this
*/
proto.somewear.api.v1.GetRoutesRequest.prototype.setFrom = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.somewear.api.v1.GetRoutesRequest} returns this
 */
proto.somewear.api.v1.GetRoutesRequest.prototype.clearFrom = function() {
  return this.setFrom(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.somewear.api.v1.GetRoutesRequest.prototype.hasFrom = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Timestamp to = 2;
 * @return {?proto.Timestamp}
 */
proto.somewear.api.v1.GetRoutesRequest.prototype.getTo = function() {
  return /** @type{?proto.Timestamp} */ (
    jspb.Message.getWrapperField(this, timestamp_proto_pb.Timestamp, 2));
};


/**
 * @param {?proto.Timestamp|undefined} value
 * @return {!proto.somewear.api.v1.GetRoutesRequest} returns this
*/
proto.somewear.api.v1.GetRoutesRequest.prototype.setTo = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.somewear.api.v1.GetRoutesRequest} returns this
 */
proto.somewear.api.v1.GetRoutesRequest.prototype.clearTo = function() {
  return this.setTo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.somewear.api.v1.GetRoutesRequest.prototype.hasTo = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.somewear.api.v1.GetRoutesResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.somewear.api.v1.GetRoutesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.somewear.api.v1.GetRoutesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.somewear.api.v1.GetRoutesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.GetRoutesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
routesList: jspb.Message.toObjectList(msg.getRoutesList(),
    route_proto_pb.RouteResponse.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.somewear.api.v1.GetRoutesResponse}
 */
proto.somewear.api.v1.GetRoutesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.somewear.api.v1.GetRoutesResponse;
  return proto.somewear.api.v1.GetRoutesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.somewear.api.v1.GetRoutesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.somewear.api.v1.GetRoutesResponse}
 */
proto.somewear.api.v1.GetRoutesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new route_proto_pb.RouteResponse;
      reader.readMessage(value,route_proto_pb.RouteResponse.deserializeBinaryFromReader);
      msg.addRoutes(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.somewear.api.v1.GetRoutesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.somewear.api.v1.GetRoutesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.somewear.api.v1.GetRoutesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.GetRoutesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRoutesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      route_proto_pb.RouteResponse.serializeBinaryToWriter
    );
  }
};


/**
 * repeated RouteResponse routes = 1;
 * @return {!Array<!proto.RouteResponse>}
 */
proto.somewear.api.v1.GetRoutesResponse.prototype.getRoutesList = function() {
  return /** @type{!Array<!proto.RouteResponse>} */ (
    jspb.Message.getRepeatedWrapperField(this, route_proto_pb.RouteResponse, 1));
};


/**
 * @param {!Array<!proto.RouteResponse>} value
 * @return {!proto.somewear.api.v1.GetRoutesResponse} returns this
*/
proto.somewear.api.v1.GetRoutesResponse.prototype.setRoutesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.RouteResponse=} opt_value
 * @param {number=} opt_index
 * @return {!proto.RouteResponse}
 */
proto.somewear.api.v1.GetRoutesResponse.prototype.addRoutes = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.RouteResponse, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.somewear.api.v1.GetRoutesResponse} returns this
 */
proto.somewear.api.v1.GetRoutesResponse.prototype.clearRoutesList = function() {
  return this.setRoutesList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.somewear.api.v1.GetWorkspaceRoutesRequest.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.somewear.api.v1.GetWorkspaceRoutesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.somewear.api.v1.GetWorkspaceRoutesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.somewear.api.v1.GetWorkspaceRoutesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.GetWorkspaceRoutesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
workspaceId: jspb.Message.getFieldWithDefault(msg, 1, ""),
from: (f = msg.getFrom()) && timestamp_proto_pb.Timestamp.toObject(includeInstance, f),
to: (f = msg.getTo()) && timestamp_proto_pb.Timestamp.toObject(includeInstance, f),
routeTypesList: (f = jspb.Message.getRepeatedField(msg, 4)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.somewear.api.v1.GetWorkspaceRoutesRequest}
 */
proto.somewear.api.v1.GetWorkspaceRoutesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.somewear.api.v1.GetWorkspaceRoutesRequest;
  return proto.somewear.api.v1.GetWorkspaceRoutesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.somewear.api.v1.GetWorkspaceRoutesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.somewear.api.v1.GetWorkspaceRoutesRequest}
 */
proto.somewear.api.v1.GetWorkspaceRoutesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setWorkspaceId(value);
      break;
    case 2:
      var value = new timestamp_proto_pb.Timestamp;
      reader.readMessage(value,timestamp_proto_pb.Timestamp.deserializeBinaryFromReader);
      msg.setFrom(value);
      break;
    case 3:
      var value = new timestamp_proto_pb.Timestamp;
      reader.readMessage(value,timestamp_proto_pb.Timestamp.deserializeBinaryFromReader);
      msg.setTo(value);
      break;
    case 4:
      var values = /** @type {!Array<!proto.somewear.api.v1.GetWorkspaceRoutesRequest.RouteType>} */ (reader.isDelimited() ? reader.readPackedEnum() : [reader.readEnum()]);
      for (var i = 0; i < values.length; i++) {
        msg.addRouteTypes(values[i]);
      }
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.somewear.api.v1.GetWorkspaceRoutesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.somewear.api.v1.GetWorkspaceRoutesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.somewear.api.v1.GetWorkspaceRoutesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.GetWorkspaceRoutesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getWorkspaceId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFrom();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      timestamp_proto_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getTo();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      timestamp_proto_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getRouteTypesList();
  if (f.length > 0) {
    writer.writePackedEnum(
      4,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.somewear.api.v1.GetWorkspaceRoutesRequest.RouteType = {
  ROUTE_TYPE_UNSPECIFIED: 0,
  ROUTE_TYPE_RESOURCES: 1,
  ROUTE_TYPE_USERS: 2,
  ROUTE_TYPE_DEVICES: 3
};

/**
 * optional string workspace_id = 1;
 * @return {string}
 */
proto.somewear.api.v1.GetWorkspaceRoutesRequest.prototype.getWorkspaceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.somewear.api.v1.GetWorkspaceRoutesRequest} returns this
 */
proto.somewear.api.v1.GetWorkspaceRoutesRequest.prototype.setWorkspaceId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional Timestamp from = 2;
 * @return {?proto.Timestamp}
 */
proto.somewear.api.v1.GetWorkspaceRoutesRequest.prototype.getFrom = function() {
  return /** @type{?proto.Timestamp} */ (
    jspb.Message.getWrapperField(this, timestamp_proto_pb.Timestamp, 2));
};


/**
 * @param {?proto.Timestamp|undefined} value
 * @return {!proto.somewear.api.v1.GetWorkspaceRoutesRequest} returns this
*/
proto.somewear.api.v1.GetWorkspaceRoutesRequest.prototype.setFrom = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.somewear.api.v1.GetWorkspaceRoutesRequest} returns this
 */
proto.somewear.api.v1.GetWorkspaceRoutesRequest.prototype.clearFrom = function() {
  return this.setFrom(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.somewear.api.v1.GetWorkspaceRoutesRequest.prototype.hasFrom = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional Timestamp to = 3;
 * @return {?proto.Timestamp}
 */
proto.somewear.api.v1.GetWorkspaceRoutesRequest.prototype.getTo = function() {
  return /** @type{?proto.Timestamp} */ (
    jspb.Message.getWrapperField(this, timestamp_proto_pb.Timestamp, 3));
};


/**
 * @param {?proto.Timestamp|undefined} value
 * @return {!proto.somewear.api.v1.GetWorkspaceRoutesRequest} returns this
*/
proto.somewear.api.v1.GetWorkspaceRoutesRequest.prototype.setTo = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.somewear.api.v1.GetWorkspaceRoutesRequest} returns this
 */
proto.somewear.api.v1.GetWorkspaceRoutesRequest.prototype.clearTo = function() {
  return this.setTo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.somewear.api.v1.GetWorkspaceRoutesRequest.prototype.hasTo = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * repeated RouteType route_types = 4;
 * @return {!Array<!proto.somewear.api.v1.GetWorkspaceRoutesRequest.RouteType>}
 */
proto.somewear.api.v1.GetWorkspaceRoutesRequest.prototype.getRouteTypesList = function() {
  return /** @type {!Array<!proto.somewear.api.v1.GetWorkspaceRoutesRequest.RouteType>} */ (jspb.Message.getRepeatedField(this, 4));
};


/**
 * @param {!Array<!proto.somewear.api.v1.GetWorkspaceRoutesRequest.RouteType>} value
 * @return {!proto.somewear.api.v1.GetWorkspaceRoutesRequest} returns this
 */
proto.somewear.api.v1.GetWorkspaceRoutesRequest.prototype.setRouteTypesList = function(value) {
  return jspb.Message.setField(this, 4, value || []);
};


/**
 * @param {!proto.somewear.api.v1.GetWorkspaceRoutesRequest.RouteType} value
 * @param {number=} opt_index
 * @return {!proto.somewear.api.v1.GetWorkspaceRoutesRequest} returns this
 */
proto.somewear.api.v1.GetWorkspaceRoutesRequest.prototype.addRouteTypes = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 4, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.somewear.api.v1.GetWorkspaceRoutesRequest} returns this
 */
proto.somewear.api.v1.GetWorkspaceRoutesRequest.prototype.clearRouteTypesList = function() {
  return this.setRouteTypesList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.somewear.api.v1.GetWorkspaceRoutesResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.somewear.api.v1.GetWorkspaceRoutesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.somewear.api.v1.GetWorkspaceRoutesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.somewear.api.v1.GetWorkspaceRoutesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.GetWorkspaceRoutesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
routesList: jspb.Message.toObjectList(msg.getRoutesList(),
    route_proto_pb.RouteResponse.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.somewear.api.v1.GetWorkspaceRoutesResponse}
 */
proto.somewear.api.v1.GetWorkspaceRoutesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.somewear.api.v1.GetWorkspaceRoutesResponse;
  return proto.somewear.api.v1.GetWorkspaceRoutesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.somewear.api.v1.GetWorkspaceRoutesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.somewear.api.v1.GetWorkspaceRoutesResponse}
 */
proto.somewear.api.v1.GetWorkspaceRoutesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new route_proto_pb.RouteResponse;
      reader.readMessage(value,route_proto_pb.RouteResponse.deserializeBinaryFromReader);
      msg.addRoutes(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.somewear.api.v1.GetWorkspaceRoutesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.somewear.api.v1.GetWorkspaceRoutesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.somewear.api.v1.GetWorkspaceRoutesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.GetWorkspaceRoutesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRoutesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      route_proto_pb.RouteResponse.serializeBinaryToWriter
    );
  }
};


/**
 * repeated RouteResponse routes = 1;
 * @return {!Array<!proto.RouteResponse>}
 */
proto.somewear.api.v1.GetWorkspaceRoutesResponse.prototype.getRoutesList = function() {
  return /** @type{!Array<!proto.RouteResponse>} */ (
    jspb.Message.getRepeatedWrapperField(this, route_proto_pb.RouteResponse, 1));
};


/**
 * @param {!Array<!proto.RouteResponse>} value
 * @return {!proto.somewear.api.v1.GetWorkspaceRoutesResponse} returns this
*/
proto.somewear.api.v1.GetWorkspaceRoutesResponse.prototype.setRoutesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.RouteResponse=} opt_value
 * @param {number=} opt_index
 * @return {!proto.RouteResponse}
 */
proto.somewear.api.v1.GetWorkspaceRoutesResponse.prototype.addRoutes = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.RouteResponse, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.somewear.api.v1.GetWorkspaceRoutesResponse} returns this
 */
proto.somewear.api.v1.GetWorkspaceRoutesResponse.prototype.clearRoutesList = function() {
  return this.setRoutesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.somewear.api.v1.GetWaypointsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.somewear.api.v1.GetWaypointsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.somewear.api.v1.GetWaypointsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.GetWaypointsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.somewear.api.v1.GetWaypointsRequest}
 */
proto.somewear.api.v1.GetWaypointsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.somewear.api.v1.GetWaypointsRequest;
  return proto.somewear.api.v1.GetWaypointsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.somewear.api.v1.GetWaypointsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.somewear.api.v1.GetWaypointsRequest}
 */
proto.somewear.api.v1.GetWaypointsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.somewear.api.v1.GetWaypointsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.somewear.api.v1.GetWaypointsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.somewear.api.v1.GetWaypointsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.GetWaypointsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.somewear.api.v1.GetWaypointsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.somewear.api.v1.GetWaypointsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.somewear.api.v1.GetWaypointsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.somewear.api.v1.GetWaypointsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.GetWaypointsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
routesList: jspb.Message.toObjectList(msg.getRoutesList(),
    route_proto_pb.RouteResponse.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.somewear.api.v1.GetWaypointsResponse}
 */
proto.somewear.api.v1.GetWaypointsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.somewear.api.v1.GetWaypointsResponse;
  return proto.somewear.api.v1.GetWaypointsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.somewear.api.v1.GetWaypointsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.somewear.api.v1.GetWaypointsResponse}
 */
proto.somewear.api.v1.GetWaypointsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new route_proto_pb.RouteResponse;
      reader.readMessage(value,route_proto_pb.RouteResponse.deserializeBinaryFromReader);
      msg.addRoutes(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.somewear.api.v1.GetWaypointsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.somewear.api.v1.GetWaypointsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.somewear.api.v1.GetWaypointsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.GetWaypointsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRoutesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      route_proto_pb.RouteResponse.serializeBinaryToWriter
    );
  }
};


/**
 * repeated RouteResponse routes = 1;
 * @return {!Array<!proto.RouteResponse>}
 */
proto.somewear.api.v1.GetWaypointsResponse.prototype.getRoutesList = function() {
  return /** @type{!Array<!proto.RouteResponse>} */ (
    jspb.Message.getRepeatedWrapperField(this, route_proto_pb.RouteResponse, 1));
};


/**
 * @param {!Array<!proto.RouteResponse>} value
 * @return {!proto.somewear.api.v1.GetWaypointsResponse} returns this
*/
proto.somewear.api.v1.GetWaypointsResponse.prototype.setRoutesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.RouteResponse=} opt_value
 * @param {number=} opt_index
 * @return {!proto.RouteResponse}
 */
proto.somewear.api.v1.GetWaypointsResponse.prototype.addRoutes = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.RouteResponse, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.somewear.api.v1.GetWaypointsResponse} returns this
 */
proto.somewear.api.v1.GetWaypointsResponse.prototype.clearRoutesList = function() {
  return this.setRoutesList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.somewear.api.v1.GetRouteLocationsRequest.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.somewear.api.v1.GetRouteLocationsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.somewear.api.v1.GetRouteLocationsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.somewear.api.v1.GetRouteLocationsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.GetRouteLocationsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
routeIdsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
from: (f = msg.getFrom()) && timestamp_proto_pb.Timestamp.toObject(includeInstance, f),
to: (f = msg.getTo()) && timestamp_proto_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.somewear.api.v1.GetRouteLocationsRequest}
 */
proto.somewear.api.v1.GetRouteLocationsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.somewear.api.v1.GetRouteLocationsRequest;
  return proto.somewear.api.v1.GetRouteLocationsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.somewear.api.v1.GetRouteLocationsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.somewear.api.v1.GetRouteLocationsRequest}
 */
proto.somewear.api.v1.GetRouteLocationsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addRouteIds(value);
      break;
    case 2:
      var value = new timestamp_proto_pb.Timestamp;
      reader.readMessage(value,timestamp_proto_pb.Timestamp.deserializeBinaryFromReader);
      msg.setFrom(value);
      break;
    case 3:
      var value = new timestamp_proto_pb.Timestamp;
      reader.readMessage(value,timestamp_proto_pb.Timestamp.deserializeBinaryFromReader);
      msg.setTo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.somewear.api.v1.GetRouteLocationsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.somewear.api.v1.GetRouteLocationsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.somewear.api.v1.GetRouteLocationsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.GetRouteLocationsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRouteIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
  f = message.getFrom();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      timestamp_proto_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getTo();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      timestamp_proto_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * repeated string route_ids = 1;
 * @return {!Array<string>}
 */
proto.somewear.api.v1.GetRouteLocationsRequest.prototype.getRouteIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.somewear.api.v1.GetRouteLocationsRequest} returns this
 */
proto.somewear.api.v1.GetRouteLocationsRequest.prototype.setRouteIdsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.somewear.api.v1.GetRouteLocationsRequest} returns this
 */
proto.somewear.api.v1.GetRouteLocationsRequest.prototype.addRouteIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.somewear.api.v1.GetRouteLocationsRequest} returns this
 */
proto.somewear.api.v1.GetRouteLocationsRequest.prototype.clearRouteIdsList = function() {
  return this.setRouteIdsList([]);
};


/**
 * optional Timestamp from = 2;
 * @return {?proto.Timestamp}
 */
proto.somewear.api.v1.GetRouteLocationsRequest.prototype.getFrom = function() {
  return /** @type{?proto.Timestamp} */ (
    jspb.Message.getWrapperField(this, timestamp_proto_pb.Timestamp, 2));
};


/**
 * @param {?proto.Timestamp|undefined} value
 * @return {!proto.somewear.api.v1.GetRouteLocationsRequest} returns this
*/
proto.somewear.api.v1.GetRouteLocationsRequest.prototype.setFrom = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.somewear.api.v1.GetRouteLocationsRequest} returns this
 */
proto.somewear.api.v1.GetRouteLocationsRequest.prototype.clearFrom = function() {
  return this.setFrom(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.somewear.api.v1.GetRouteLocationsRequest.prototype.hasFrom = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional Timestamp to = 3;
 * @return {?proto.Timestamp}
 */
proto.somewear.api.v1.GetRouteLocationsRequest.prototype.getTo = function() {
  return /** @type{?proto.Timestamp} */ (
    jspb.Message.getWrapperField(this, timestamp_proto_pb.Timestamp, 3));
};


/**
 * @param {?proto.Timestamp|undefined} value
 * @return {!proto.somewear.api.v1.GetRouteLocationsRequest} returns this
*/
proto.somewear.api.v1.GetRouteLocationsRequest.prototype.setTo = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.somewear.api.v1.GetRouteLocationsRequest} returns this
 */
proto.somewear.api.v1.GetRouteLocationsRequest.prototype.clearTo = function() {
  return this.setTo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.somewear.api.v1.GetRouteLocationsRequest.prototype.hasTo = function() {
  return jspb.Message.getField(this, 3) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.somewear.api.v1.GetRouteLocationsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.somewear.api.v1.GetRouteLocationsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.somewear.api.v1.GetRouteLocationsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.somewear.api.v1.GetRouteLocationsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.GetRouteLocationsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
locationsList: jspb.Message.toObjectList(msg.getLocationsList(),
    location_proto_pb.LocationResponse.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.somewear.api.v1.GetRouteLocationsResponse}
 */
proto.somewear.api.v1.GetRouteLocationsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.somewear.api.v1.GetRouteLocationsResponse;
  return proto.somewear.api.v1.GetRouteLocationsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.somewear.api.v1.GetRouteLocationsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.somewear.api.v1.GetRouteLocationsResponse}
 */
proto.somewear.api.v1.GetRouteLocationsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new location_proto_pb.LocationResponse;
      reader.readMessage(value,location_proto_pb.LocationResponse.deserializeBinaryFromReader);
      msg.addLocations(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.somewear.api.v1.GetRouteLocationsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.somewear.api.v1.GetRouteLocationsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.somewear.api.v1.GetRouteLocationsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.GetRouteLocationsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLocationsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      location_proto_pb.LocationResponse.serializeBinaryToWriter
    );
  }
};


/**
 * repeated LocationResponse locations = 1;
 * @return {!Array<!proto.LocationResponse>}
 */
proto.somewear.api.v1.GetRouteLocationsResponse.prototype.getLocationsList = function() {
  return /** @type{!Array<!proto.LocationResponse>} */ (
    jspb.Message.getRepeatedWrapperField(this, location_proto_pb.LocationResponse, 1));
};


/**
 * @param {!Array<!proto.LocationResponse>} value
 * @return {!proto.somewear.api.v1.GetRouteLocationsResponse} returns this
*/
proto.somewear.api.v1.GetRouteLocationsResponse.prototype.setLocationsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.LocationResponse=} opt_value
 * @param {number=} opt_index
 * @return {!proto.LocationResponse}
 */
proto.somewear.api.v1.GetRouteLocationsResponse.prototype.addLocations = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.LocationResponse, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.somewear.api.v1.GetRouteLocationsResponse} returns this
 */
proto.somewear.api.v1.GetRouteLocationsResponse.prototype.clearLocationsList = function() {
  return this.setLocationsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.somewear.api.v1.ExportGpxRequest.repeatedFields_ = [1,2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.somewear.api.v1.ExportGpxRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.somewear.api.v1.ExportGpxRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.somewear.api.v1.ExportGpxRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.ExportGpxRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
routesList: jspb.Message.toObjectList(msg.getRoutesList(),
    route_proto_pb.RouteResponse.toObject, includeInstance),
locationsList: jspb.Message.toObjectList(msg.getLocationsList(),
    location_proto_pb.LocationResponse.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.somewear.api.v1.ExportGpxRequest}
 */
proto.somewear.api.v1.ExportGpxRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.somewear.api.v1.ExportGpxRequest;
  return proto.somewear.api.v1.ExportGpxRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.somewear.api.v1.ExportGpxRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.somewear.api.v1.ExportGpxRequest}
 */
proto.somewear.api.v1.ExportGpxRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new route_proto_pb.RouteResponse;
      reader.readMessage(value,route_proto_pb.RouteResponse.deserializeBinaryFromReader);
      msg.addRoutes(value);
      break;
    case 2:
      var value = new location_proto_pb.LocationResponse;
      reader.readMessage(value,location_proto_pb.LocationResponse.deserializeBinaryFromReader);
      msg.addLocations(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.somewear.api.v1.ExportGpxRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.somewear.api.v1.ExportGpxRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.somewear.api.v1.ExportGpxRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.ExportGpxRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRoutesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      route_proto_pb.RouteResponse.serializeBinaryToWriter
    );
  }
  f = message.getLocationsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      location_proto_pb.LocationResponse.serializeBinaryToWriter
    );
  }
};


/**
 * repeated RouteResponse routes = 1;
 * @return {!Array<!proto.RouteResponse>}
 */
proto.somewear.api.v1.ExportGpxRequest.prototype.getRoutesList = function() {
  return /** @type{!Array<!proto.RouteResponse>} */ (
    jspb.Message.getRepeatedWrapperField(this, route_proto_pb.RouteResponse, 1));
};


/**
 * @param {!Array<!proto.RouteResponse>} value
 * @return {!proto.somewear.api.v1.ExportGpxRequest} returns this
*/
proto.somewear.api.v1.ExportGpxRequest.prototype.setRoutesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.RouteResponse=} opt_value
 * @param {number=} opt_index
 * @return {!proto.RouteResponse}
 */
proto.somewear.api.v1.ExportGpxRequest.prototype.addRoutes = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.RouteResponse, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.somewear.api.v1.ExportGpxRequest} returns this
 */
proto.somewear.api.v1.ExportGpxRequest.prototype.clearRoutesList = function() {
  return this.setRoutesList([]);
};


/**
 * repeated LocationResponse locations = 2;
 * @return {!Array<!proto.LocationResponse>}
 */
proto.somewear.api.v1.ExportGpxRequest.prototype.getLocationsList = function() {
  return /** @type{!Array<!proto.LocationResponse>} */ (
    jspb.Message.getRepeatedWrapperField(this, location_proto_pb.LocationResponse, 2));
};


/**
 * @param {!Array<!proto.LocationResponse>} value
 * @return {!proto.somewear.api.v1.ExportGpxRequest} returns this
*/
proto.somewear.api.v1.ExportGpxRequest.prototype.setLocationsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.LocationResponse=} opt_value
 * @param {number=} opt_index
 * @return {!proto.LocationResponse}
 */
proto.somewear.api.v1.ExportGpxRequest.prototype.addLocations = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.LocationResponse, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.somewear.api.v1.ExportGpxRequest} returns this
 */
proto.somewear.api.v1.ExportGpxRequest.prototype.clearLocationsList = function() {
  return this.setLocationsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.somewear.api.v1.ExportGpxResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.somewear.api.v1.ExportGpxResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.somewear.api.v1.ExportGpxResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.ExportGpxResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
data: msg.getData_asB64()
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.somewear.api.v1.ExportGpxResponse}
 */
proto.somewear.api.v1.ExportGpxResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.somewear.api.v1.ExportGpxResponse;
  return proto.somewear.api.v1.ExportGpxResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.somewear.api.v1.ExportGpxResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.somewear.api.v1.ExportGpxResponse}
 */
proto.somewear.api.v1.ExportGpxResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.somewear.api.v1.ExportGpxResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.somewear.api.v1.ExportGpxResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.somewear.api.v1.ExportGpxResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.somewear.api.v1.ExportGpxResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getData_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      1,
      f
    );
  }
};


/**
 * optional bytes data = 1;
 * @return {!(string|Uint8Array)}
 */
proto.somewear.api.v1.ExportGpxResponse.prototype.getData = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * optional bytes data = 1;
 * This is a type-conversion wrapper around `getData()`
 * @return {string}
 */
proto.somewear.api.v1.ExportGpxResponse.prototype.getData_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getData()));
};


/**
 * optional bytes data = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getData()`
 * @return {!Uint8Array}
 */
proto.somewear.api.v1.ExportGpxResponse.prototype.getData_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getData()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.somewear.api.v1.ExportGpxResponse} returns this
 */
proto.somewear.api.v1.ExportGpxResponse.prototype.setData = function(value) {
  return jspb.Message.setProto3BytesField(this, 1, value);
};


goog.object.extend(exports, proto.somewear.api.v1);
